import { Dispatch, SetStateAction } from 'react'

export interface layoutContext {
    sidebar: boolean,
    header: boolean,
    footer: boolean,
    setSidebar: Dispatch<SetStateAction<boolean>>,
    setHeader: Dispatch<SetStateAction<boolean>>,
    setFooter: Dispatch<SetStateAction<boolean>>,
    titleLocation: string,
    setTitleLocation: Dispatch<SetStateAction<string>>
    descriptionLocation: string,
    setDescriptionLocation: Dispatch<SetStateAction<string>>,
    navLocation: string,
    setNavLocation: Dispatch<SetStateAction<string>>
    likes: boolean,
    setLikes: Dispatch<SetStateAction<boolean>>
    reblogs: boolean,
    setReblogs: Dispatch<SetStateAction<boolean>>,
    postInfo: boolean,
    setPostInfo: Dispatch<SetStateAction<boolean>>,
    layout: string,
    setLayout: Dispatch<SetStateAction<string>>,
    postSize: string,
    setPostSize: Dispatch<SetStateAction<string>>,
    gridSize: string,
    setGridSize: Dispatch<SetStateAction<string>>,
    sidebarStyle: string,
    setSidebarStyle: Dispatch<SetStateAction<string>>,
    sidebarLocation: boolean,
    setSidebarLocation: Dispatch<SetStateAction<boolean>>,
    sideImage: string,
    setSideImage: Dispatch<SetStateAction<string>>,
    updatesTab: string,
    setUpdatesTab: Dispatch<SetStateAction<string>>,
    searchBar: string,
    setSearchBar: Dispatch<SetStateAction<string>>,
    customCursor: boolean,
    setCustomCursor: Dispatch<SetStateAction<boolean>>,
    daynight: boolean,
    setdaynight: Dispatch<SetStateAction<boolean>>,
    keyboardNav: boolean,
    setKeyboardNav: Dispatch<SetStateAction<boolean>>,
    pinnedPost: string,
    setPinnedPost: Dispatch<SetStateAction<string>>,
    pagi: string,
    setPagi: Dispatch<SetStateAction<string>>,
  }
  
  export const initialValues = {
    sidebar: false,
    header: false,
    footer: false,
    setSidebar: () => { },
    setHeader: () => { },
    setFooter: () => { },
    titleLocation: 'none',
    setTitleLocation: () => { },
    descriptionLocation: 'none',
    setDescriptionLocation: () => { },
    navLocation: 'none',
    setNavLocation: () => { },
    likes: false,
    setLikes: () => { },
    reblogs: false,
    setReblogs: () => { },
    postInfo: false,
    setPostInfo: () => { },
    layout: '',
    setLayout: () => { },
    postSize: '',
    setPostSize: () => { },
    gridSize: '',
    setGridSize: () => { },
    sidebarStyle: '',
    setSidebarStyle: () => { },
    sidebarLocation: false,
    setSidebarLocation: () => { },
    sideImage: '',
    setSideImage: () => { },
    updatesTab: '',
    setUpdatesTab: () => { },
    searchBar: '',
    setSearchBar: () => { },
    customCursor: false,
    setCustomCursor: () => { },
    daynight: false,
    setdaynight: () => { },
    keyboardNav: false,
    setKeyboardNav: () => { },
    pinnedPost: 'default',
    setPinnedPost: () => { },
    pagi: 'posts',
    setPagi: () => { },
  }